import StatusFilterTabs from './StatusFilterTabs';
import { ENTITY_STATUS_TABS, matchesEntityStatus } from '../../utils/status';

type EntityStatusFilterTabsProps = {
  filterStatus: string;
  onFilterStatusChange: (value: string) => void;
  loading: boolean;
  /** Rows used for per-tab counts (typically the unfiltered stats set). */
  items: { status?: string | null }[];
  ariaLabel?: string;
};

export default function EntityStatusFilterTabs({
  filterStatus,
  onFilterStatusChange,
  loading,
  items,
  ariaLabel = 'Status',
}: EntityStatusFilterTabsProps) {
  return (
    <StatusFilterTabs
      tabs={ENTITY_STATUS_TABS}
      value={filterStatus}
      onChange={onFilterStatusChange}
      disabled={loading}
      ariaLabel={ariaLabel}
      className="w-auto max-w-full shrink-0"
      getCount={(tab) => {
        const key = typeof tab === 'string' ? tab : tab.value;
        if (key === 'All') return items.length;
        return items.filter((row) => matchesEntityStatus(row.status, key)).length;
      }}
    />
  );
}
